var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headTab"},[_c('div',{staticClass:"headTab_top"},[_c('van-icon',{staticStyle:{"position":"absolute","left":"10px"},attrs:{"size":"25","name":"arrow-left"},on:{"click":function($event){return _vm.to()}}}),_c('div',{staticClass:"my"},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }